import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { ChipButton, Typography } from 'seagull';
import { DropdownMenu } from 'seagull/components/DropdownMenu';
import { Archive, ChevronDown, ChevronUp, Trash } from 'seagull/icons';
import { useStoreActions } from '~/contexts';
import pluralize from '~/utils/pluralize';
import styles from './ContactsBulkActions.module.scss';
const bulkActionsBiEventIds = {
    dropdownOpen: 11610,
    archive: 11611,
    delete: 11612
};
const ContactsBulkActions = (param)=>{
    let { numSelected, onBulkArchive, onBulkDelete } = param;
    const [isOpen, setIsOpen] = useState(false);
    const { logBI } = useStoreActions();
    const handleOpenChange = (open)=>{
        setIsOpen(open);
        if (open) {
            logBI(bulkActionsBiEventIds.dropdownOpen, {
                numSelected
            });
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                className: styles.selectedItems,
                testId: "contacts-bulk-counter",
                children: numSelected > 0 ? "".concat(numSelected, " ").concat(pluralize('contact', numSelected), " selected") : ''
            }),
            /*#__PURE__*/ _jsxs(DropdownMenu, {
                onOpenChange: handleOpenChange,
                target: /*#__PURE__*/ _jsx(ChipButton, {
                    testId: "contacts-bulk-actions",
                    suffixIcon: isOpen ? /*#__PURE__*/ _jsx(ChevronUp, {}) : /*#__PURE__*/ _jsx(ChevronDown, {}),
                    highlight: isOpen,
                    disabled: numSelected === 0,
                    children: "Bulk actions"
                }),
                children: [
                    /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                        iconStart: /*#__PURE__*/ _jsx(Archive, {}),
                        testId: "contacts-bulk-archive",
                        onClick: ()=>{
                            logBI(bulkActionsBiEventIds.archive, {
                                numSelected
                            });
                            onBulkArchive();
                        },
                        children: "Archive"
                    }),
                    /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                        iconStart: /*#__PURE__*/ _jsx(Trash, {
                            size: 20
                        }),
                        testId: "contacts-bulk-delete",
                        skin: "error",
                        onClick: ()=>{
                            logBI(bulkActionsBiEventIds.delete, {
                                numSelected
                            });
                            onBulkDelete();
                        },
                        children: "Delete"
                    })
                ]
            })
        ]
    });
};
export default ContactsBulkActions;
